import React, { Component, useCallback, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import _ from "lodash";
import moment from "moment-jalaali";

function DataGrid({ data, setSelectedCheckBoxes, selectedCheckBoxes }) {
  const [lastSelected, setLastSelected] = useState(null);

  const handleToggle = useCallback((id, event) => {
    const isShiftPressed = event.shiftKey;

    if (isShiftPressed && lastSelected !== null) {
      // Find the range between lastSelected and current id
      const startIndex = data?.data?.findIndex((item) => item.id === lastSelected);
      const endIndex = data?.data?.findIndex((item) => item.id === id);
      const range = data?.data?.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1);
      const allIdsInRange = range.map((item) => item.id);

      // Add the first selected checkbox to the list if not already added
      setSelectedCheckBoxes((prevSelected) => {
        // Start by adding the first selected checkbox to the list
        const newSelected = [...prevSelected, lastSelected];

        // Now invert the checkboxes within the range
        allIdsInRange.forEach((checkboxId) => {
          const index = newSelected.indexOf(checkboxId);
          if (index === -1) {
            newSelected.push(checkboxId); // Add if not selected
          } else {
            newSelected.splice(index, 1); // Remove if already selected
          }
        });

        return newSelected;
      });
    } else {
      // If shift is not pressed, simply toggle the selection of this checkbox
      setSelectedCheckBoxes((prevSelected) =>
        prevSelected.includes(id) ? prevSelected.filter((selectedId) => selectedId !== id) : [...prevSelected, id],
      );
    }

    // Update the last selected checkbox
    setLastSelected(id);
  }, [data]);

  const handleToggleAll = useCallback(() => {
    if (data?.data?.length === selectedCheckBoxes.length) {
      setSelectedCheckBoxes([]);
    } else {
      const allCheckBoxesId = data?.data?.map((item) => item.id);
      setSelectedCheckBoxes([...allCheckBoxesId]);
    }
  }, [data, selectedCheckBoxes]);


  const redRows = useMemo(() => {
    return data?.data?.map(row =>
      (row.status != 4 && row.status != 3 && row.riallBalance - row.rialAmount < 0)
    );
  }, [data])
  const yellowRows = useMemo(() => {
    return data?.data?.map(row =>
      (row.isNewDestinationAccount)
    );
  }, [data])
  const columns = useMemo(
    () => [
      // {
      //   accessor: "#",
      //   Header: () => {
      //     return (
      //       <div className="text-center cursor-pointer" onClick={() => handleToggleAll()}>
      //         <input
      //           type="checkbox"
      //           checked={data?.data?.length !== 0 && data?.data?.length === selectedCheckBoxes.length}
      //           onChange={() => { }}
      //           className="ml-1 ml-xl-6 pl-6 cursor-pointer"
      //         />
      //       </div>
      //     );
      //   },
      //   minWidth: 50,
      //   Cell: ({ row }) => (
      //     <div className="text-center cursor-pointer" onClick={(e) => handleToggle(row.original.id, e)}>
      //       <input
      //         type="checkbox"
      //         checked={selectedCheckBoxes.includes(row.original.id)}
      //         onChange={() => { }}
      //         className="ml-1 ml-xl-6 pl-6 cursor-pointer"
      //       />
      //     </div>
      //   ),
      // },
      {
        accessor: "id",
        Header: "#",
        minWidth: 100,
      },
      {
        accessor: "userType",
        Header: "نوع حساب",
        minWidth: "100px",
      },
      {
        accessor: "userFullName",
        Header: "نام",
        minWidth: "100px",
      },
      {
        accessor: "phoneNumber",
        Header: "شماره تماس",
        minWidth: "100px",
      },
      {
        accessor: "accountOwnerName",
        Header: "صاحب حساب",
        minWidth: "100px",
      },
      {
        accessor: "companyName",
        Header: "شرکت",
        minWidth: "100px",
      },
      {
        accessor: "rialAmount",
        Header: "مبلغ",
        minWidth: "100px",
        maxWidth: "100px",
        Cell: ({ row }) => (
          <div className="">
            <SplitNumber number={row.original.rialAmount} />
          </div>
        ),
        Footer: (info) => {

          const total = React.useMemo(() => info.rows.reduce((sum, row) => row.original.rialAmount + sum, 0), [info.rows]);
          return (
            <div className="text-center success">
              {" "}
              <SplitNumber number={total} />
            </div>
          );
        },
      },
      {
        accessor: "statusS",
        Header: "وضعیت",
        minWidth: 100,
        Cell: ({ row }) => (
          <div
            className={` rounded-pill d-inline-block px-4 py-1 text-center ${row.original.status === 4 ? "text-danger bg-light-danger" : row.original.status === 3 ? "text-success bg-light-success" : row.original.status === 1 ? "bg-light-info text-info" : "text-primary bg-light-primary"}`}
          >
            {row.original.statusS}
          </div>
        ),
      },
      {
        Header: "تاریخ انجام",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {_.toString(row.original.paymentDate)} - {_.toString(row.original.paymentTime)}
          </div>
        ),
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 100,
      },
      {
        accessor: "accountBank",
        Header: "نام بانک حساب",
        minWidth: 100,
      },
      {
        accessor: "accountNumber",
        Header: "شماره حساب",
        minWidth: 100,
      },
      {
        accessor: "accountCardNumber",
        Header: "شماره کارت",
        minWidth: 100,
      },
      {
        accessor: "accountShebaNumber",
        Header: "شماره شبا",
        minWidth: 100,
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* ویرایش */}
            <Link
              title="ویرایش"
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              to={{
                pathname: `/userWithdrawalsDetails/${row.original.id}`,
                state: { accountType: row.original.userType },
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Link>
          </div>
        ),
      },
    ],
    [handleToggle, data, handleToggleAll],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    show_footer: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={{ ...data, data: data?.data?.map(item => ({ ...item, redTooltip: "مبلغ درخواست شده از موجودی کیف پول کاربر بیشتر است", yellowTooltip: "تاکنون هیچ درخواستی برای این حساب درج نشده است" })) }} yellowRows={yellowRows} redRows={redRows} />
    </div>
  );
}

export default DataGrid;
